// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1Nn0c","footer":"ChangeClinic_footer__2npKC"};